import axios from 'axios';
import { API_BACKEND } from '../../config';

export default class SectionClient {
  async updateSection(id, section) {
    await axios.put(`${API_BACKEND}/sections/${id}`, section.formData(), {});
  }
}
